import React from 'react';
import { motion } from 'framer-motion';
import { HeartHandshake, Flower2, UserCircle, Sparkles, Leaf, Boxes } from 'lucide-react';
const principles = [{
  title: 'For chosen family',
  description: 'We create safe environments explicitly designed for diverse family structures and their evolving needs.',
  icon: <HeartHandshake className="w-6 h-6 text-navy" data-id="element-303" />
}, {
  title: 'Enriching the urban fabric',
  description: 'The project will both benefit from the city as the greatest amenity, and contribute to a thriving neighborhood.',
  icon: <Flower2 className="w-6 h-6 text-navy" data-id="element-304" />
}, {
  title: 'Individual pragmatism',
  description: 'We identify the essentials without adding more, while honoring personal space and privacy, and recognizing that community living thrives when individual needs are thoughtfully addressed.',
  icon: <UserCircle className="w-6 h-6 text-navy" data-id="element-305" />
}, {
  title: 'Shared luxury',
  description: 'We believe abundance is enjoyed via sharing, and invest in generous common spaces and resources.',
  icon: <Sparkles className="w-6 h-6 text-navy" data-id="element-306" />
}, {
  title: 'Re-use and sustainability',
  description: 'We think collectivity leads to sustainability, and will make acquisition and design choices that are healthy for residents and the planet.',
  icon: <Leaf className="w-6 h-6 text-navy" data-id="element-307" />
}, {
  title: 'Adaptability',
  description: "We're designing for flexibility and scalability to lower construction costs, and ensure adaptability to changing needs.",
  icon: <Boxes className="w-6 h-6 text-navy" data-id="element-308" />
}];
export function VisionSection() {
  return <section className="py-32 px-6 md:px-12 bg-cream pt-[128px] pb-[48px]" data-id="element-309">
      <div className="max-w-7xl mx-auto" data-id="element-310">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-20 text-center" data-id="element-311">
          <span className="text-xs font-sans font-bold uppercase tracking-[0.2em] text-marigold mb-4 block" data-id="element-312">
            Our vision
          </span>
          <h2 className="text-4xl md:text-5xl text-navy mb-6 font-serif tracking-wide" data-id="element-313">
            Project Vision and Principles
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-24" data-id="element-314">
          {principles.map((principle, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-navy/10 p-8 flex gap-6" data-id="element-315">
              <div className="flex-shrink-0 mt-1" data-id="element-316">{principle.icon}</div>
              <div data-id="element-317">
                <h3 className="text-xl font-serif tracking-wide text-navy mb-3" data-id="element-318">
                  {principle.title}
                </h3>
                <p className="text-navy/70 text-sm leading-relaxed" data-id="element-319">
                  {principle.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center" data-id="element-320">
          <h3 className="text-3xl md:text-4xl font-serif tracking-wide text-navy mb-6" data-id="element-321">
            A city where home makes community easier.
          </h3>
          <p className="text-lg text-navy/70 font-light leading-relaxed" data-id="element-322">
            Familiar Spaces is not a commune and not a traditional apartment
            building. It is a new housing model for people who want privacy,
            ownership, design, and city life, without giving up the
            relationships that make life resilient.
          </p>
        </motion.div>
      </div>
    </section>;
}